import validate from "validate.js";
import pick from "lodash.pick";
import { INPUT_NAMES } from "utils/config";

const allowEmpty = false;

const constraints = {
	[INPUT_NAMES.name]: {
		presence: { allowEmpty, message: "validation.name" },
	},
	[INPUT_NAMES.email]: {
		presence: { allowEmpty, message: "validation.email" },
		email: { message: "validation.emailNotValid" },
	},
	[INPUT_NAMES.password]: {
		presence: { message: "validation.password" },
		length: {
			minimum: 6,
			message: "validation.passwordLimit",
		},
	},
	[INPUT_NAMES.address]: {
		presence: { allowEmpty, message: "validation.address" },
	},
	[INPUT_NAMES.suburb]: {
		presence: { allowEmpty, message: "validation.suburb" },
	},
	[INPUT_NAMES.postcode]: {
		presence: { allowEmpty, message: "validation.postcode" },
	},
	[INPUT_NAMES.state]: {
		presence: { allowEmpty, message: "validation.state" },
	},
	mobileNumber: {
		length: {
			minimum: 4,
			maximum: 15,
		},
	},
};

export default inputs => {
	const filteredConstraints = pick(constraints, Object.keys(inputs));
	return validate(inputs, filteredConstraints, { fullMessages: false });
};



// WEBPACK FOOTER //
// ./src/utils/validation.js